import { Icon } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useFullRoutes } from '~/hooks';
import { useGetUserProfileQuery } from '~/redux/api/authApiSlice';

const UserPassword = () => {
  const { MY_ACCOUNT_URL } = useFullRoutes();
  const { t } = useTranslation('app');
  const { data: userProfile } = useGetUserProfileQuery();

  return (
    <div className="border-b border-gray py-2x px-3x flex">
      <div className="flex flex-col gap-x flex-1">
        <p className="text-title_4">{t('password')}</p>
        <p className="text-body_1 text-gray__dark_1">
          {userProfile?.has_password ? '********' : t('unAvailable')}
        </p>
      </div>
      <Link to={MY_ACCOUNT_URL.UPDATE_PASSWORD}>
        {userProfile?.has_password ? (
          <Icon name="edit" className="text-blue" />
        ) : (
          <Icon name="plus" className="text-blue" />
        )}
      </Link>
    </div>
  );
};

export default UserPassword;
